import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "@/lib/authToken";
import { FOUNDING_ENTRY_PATH, resolveFoundingEntry } from "@/lib/foundingEntry";

// Claim buttons and the header Sign up / Sign in controls. A visitor who
// already has fsrs_token skips the blank form and goes to the pricing terms
// gate. Logged-out Sign in opens the modal on the login form; Sign up and
// claim buttons open it on the signup form. The in-modal toggle can still
// switch modes after it opens.
export function useFoundingEntry() {
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [authMode, setAuthMode] = useState("signup");

    const openEntry = useCallback((mode = "signup") => {
        const entry = resolveFoundingEntry(isLoggedIn(), mode);
        if (entry.type === "pricing") {
            navigate(entry.path || FOUNDING_ENTRY_PATH);
            return;
        }
        setAuthMode(entry.type === "login" ? "login" : "signup");
        setModalOpen(true);
    }, [navigate]);

    const onCtaClick = useCallback(() => openEntry("signup"), [openEntry]);
    const onSignIn = useCallback(() => openEntry("login"), [openEntry]);
    const onSignUp = useCallback(() => openEntry("signup"), [openEntry]);

    return { modalOpen, setModalOpen, authMode, setAuthMode, onCtaClick, onSignIn, onSignUp };
}
